/**
 * @desc 平台-新增
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformResponseDto>;
export function request(body: defs.basics.PlatformRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platform/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
